export default {"src":"/_next/static/media/vpbank-logo.1d286d1b.svg","height":64,"width":196,"blurWidth":0,"blurHeight":0};